import React from "react";
import styled from "styled-components";
import { SectionEyebrow, SectionTitle } from "../common/Section";

const Section = styled.section`
  padding: clamp(4rem,6vw,5.5rem) 8vw;
  border-top: 1px solid var(--ink-06);
  @media (max-width: 480px) { padding-left: 5vw; padding-right: 5vw; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px,1fr));
  gap: 24px;
  margin-top: 32px;
`;

const Card = styled.div`
  padding: 28px 24px;
  border: 1px solid var(--ink-08);
  background: rgba(255,255,255,.02);
  h3 {
    font-family: "DM Serif Display", serif;
    font-size: 1.3rem;
    color: var(--ink);
    margin-bottom: 12px;
  }
  p {
    color: var(--muted);
    line-height: 1.8;
    font-size: 14px;
  }
`;

const reasons = [
  {
    title: "Rights-first approach",
    text: "Every project starts with publishing clarity — splits, registrations, and administration handled before release, not after.",
  },
  {
    title: "Culture fluency",
    text: "We understand what lands across markets. From Afrobeats to Latin crossover, RMS operates where genre boundaries blur and audiences grow.",
  },
  {
    title: "Execution speed",
    text: "Release architecture built for momentum, not bureaucracy. We move fast without cutting corners on rights or creative quality.",
  },
  {
    title: "Global network",
    text: "Partnerships with major labels, distributors, and streaming platforms that unlock new markets and amplify cross-border reach.",
  },
];

const HomeTrust: React.FC = () => (
  <Section>
    <SectionEyebrow>Why RMS</SectionEyebrow>
    <SectionTitle>Why clients work with us.</SectionTitle>
    <Grid>
      {reasons.map((r) => (
        <Card key={r.title}>
          <h3>{r.title}</h3>
          <p>{r.text}</p>
        </Card>
      ))}
    </Grid>
  </Section>
);

export default HomeTrust;
